import React, { useState } from "react";
import "./signin.css";
import logo from "../../Media/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../../Firebase/config";
import { signInWithEmailAndPassword } from "firebase/auth";

const SignIn = () => {
  const [data, setData] = useState({
    email: "",
    password: "",
    error: null,
    loading: false,
  });

  const navigate = useNavigate();

  const { email, password, error, loading } = data;

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setData({ ...data, error: null, loading: true });
    if (!email || !password) {
      setData({ ...data, error: "All fields are required" });
    }
    try {
      const result = await signInWithEmailAndPassword(auth, email, password);

      setData({
        email: "",
        password: "",
        error: null,
        loading: false,
      });
      navigate("/");
    } catch (err) {
      setData({ ...data, error: err.message, loading: false });
    }
  };

  return (
    <div className="signin">
      <img src={logo} alt="logo-img" />
      <h2>Log into your Account</h2>
      <div className="signin-form">
        <form onSubmit={handleSubmit}>
          <label>Email</label>
          <br />
          <input
            name="email"
            type="email"
            value={email}
            placeholder="Example@email.com"
            onChange={handleChange}
          />
          <br />
          <label>Password</label>
          <br />
          <input
            name="password"
            type="password"
            value={password}
            placeholder="Enter Password"
            onChange={handleChange}
          />
          <br />
          <button className="submit-btn" disabled={loading} type="Submit">
            {loading ? "Logging in ..." : "Login"}
          </button>
          <p>
            Don't have an account? <Link to="/signUp">SignUp</Link>
          </p>
          <button className="admin-btn" type="Submit">
            Sign in as Admin
          </button>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
